module.exports = __webpack_public_path__ + "img/IMG_2024_L_Black.947771c8.jpg";